"use client";

import { useState } from "react";
import { MenuItem } from "@/lib/types";
import NavMenuItem from "./NavMenuItem";
import ServicesMegaMenu from "./ServicesMegaMenu";

// ---------- DesktopNavProps ----------
interface DesktopNavProps {
  menuItems: MenuItem[];
  scrolled: boolean;
}

const DesktopNav = ({ menuItems, scrolled }: DesktopNavProps) => {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  return (
    <nav
      className="hidden lg:block relative"
      onMouseLeave={() => setActiveMenu(null)}
    >
      <ul className="flex items-center gap-4">
        {menuItems.map((item) => (
          <NavMenuItem
            key={item.label}
            item={item}
            scrolled={scrolled}
            onHover={() => setActiveMenu(item.label)}
          />
        ))}
      </ul>

      {/* Mega menu */}
      <div className="absolute top-full left-0 w-full pt-4">
        <ServicesMegaMenu
          isOpen={activeMenu === "Services"}
          scrolled={scrolled}
          onClose={() => setActiveMenu(null)}
        />
      </div>
    </nav>
  );
};

export default DesktopNav;
